// Static reference data shared by the API and the web client.
export const NIGERIAN_STATES = [
    { code: 'AB', name: 'Abia' },
    { code: 'AD', name: 'Adamawa' },
    { code: 'AK', name: 'Akwa Ibom' },
    { code: 'AN', name: 'Anambra' },
    { code: 'BA', name: 'Bauchi' },
    { code: 'BY', name: 'Bayelsa' },
    { code: 'BE', name: 'Benue' },
    { code: 'BO', name: 'Borno' },
    { code: 'CR', name: 'Cross River' },
    { code: 'DE', name: 'Delta' },
    { code: 'EB', name: 'Ebonyi' },
    { code: 'ED', name: 'Edo' },
    { code: 'EK', name: 'Ekiti' },
    { code: 'EN', name: 'Enugu' },
    { code: 'FC', name: 'Federal Capital Territory' },
    { code: 'GO', name: 'Gombe' },
    { code: 'IM', name: 'Imo' },
    { code: 'JI', name: 'Jigawa' },
    { code: 'KD', name: 'Kaduna' },
    { code: 'KN', name: 'Kano' },
    { code: 'KT', name: 'Katsina' },
    { code: 'KE', name: 'Kebbi' },
    { code: 'KO', name: 'Kogi' },
    { code: 'KW', name: 'Kwara' },
    { code: 'LA', name: 'Lagos' },
    { code: 'NA', name: 'Nasarawa' },
    { code: 'NI', name: 'Niger' },
    { code: 'OG', name: 'Ogun' },
    { code: 'ON', name: 'Ondo' },
    { code: 'OS', name: 'Osun' },
    { code: 'OY', name: 'Oyo' },
    { code: 'PL', name: 'Plateau' },
    { code: 'RI', name: 'Rivers' },
    { code: 'SO', name: 'Sokoto' },
    { code: 'TA', name: 'Taraba' },
    { code: 'YO', name: 'Yobe' },
    { code: 'ZA', name: 'Zamfara' },
];
/**
 * Currencies the Portal supports. All use two minor-unit digits, which matches
 * the NUMERIC(18,2) money columns. Adding a 0- or 3-decimal currency requires
 * a schema and rounding review first.
 */
export const SUPPORTED_CURRENCIES = [
    { code: 'NGN', name: 'Nigerian Naira', symbol: '₦' },
    { code: 'USD', name: 'US Dollar', symbol: '$' },
    { code: 'EUR', name: 'Euro', symbol: '€' },
    { code: 'GBP', name: 'Pound Sterling', symbol: '£' },
    { code: 'GHS', name: 'Ghanaian Cedi', symbol: 'GH₵' },
    { code: 'KES', name: 'Kenyan Shilling', symbol: 'KSh' },
    { code: 'ZAR', name: 'South African Rand', symbol: 'R' },
];
export const PRICE_UNITS = [
    { code: 'EA', label: 'Each' },
    { code: 'HUR', label: 'Hour' },
    { code: 'DAY', label: 'Day' },
    { code: 'MON', label: 'Month' },
    { code: 'KGM', label: 'Kilogram' },
    { code: 'LTR', label: 'Litre' },
    { code: 'MTR', label: 'Metre' },
    { code: 'MTK', label: 'Square metre' },
    { code: 'BX', label: 'Box' },
    { code: 'PK', label: 'Pack' },
    { code: 'SET', label: 'Set' },
    { code: 'LS', label: 'Lump sum' },
];
export const PAYMENT_METHODS = [
    { code: 'bank_transfer', label: 'Bank transfer' },
    { code: 'cash', label: 'Cash' },
    { code: 'card', label: 'Card' },
    { code: 'cheque', label: 'Cheque' },
    { code: 'mobile_money', label: 'Mobile money' },
    { code: 'other', label: 'Other' },
];
export const BUSINESS_TYPES = [
    'Sole proprietorship',
    'Partnership',
    'Limited liability company',
    'Public limited company',
    'Non-profit organisation',
    'Other',
];
/** Default tax categories seeded into every database. Rates are defaults only. */
export const DEFAULT_TAX_CATEGORIES = [
    {
        code: 'VAT',
        name: 'Value-added tax',
        description: 'Standard-rated supplies (default rate 7.5%).',
        defaultPercent: '7.5',
    },
    {
        code: 'ZERO_RATED',
        name: 'Zero-rated',
        description: 'Taxable supplies charged at 0%.',
        defaultPercent: '0',
    },
    {
        code: 'EXEMPT',
        name: 'Exempt',
        description: 'Supplies exempt from tax.',
        defaultPercent: '0',
    },
];
//# sourceMappingURL=reference.js.map